import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: theme.spacing.space24,
    width: "100%",
    textAlign: "left",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing.space8,
    textAlign: "center",
  },
  /** Matches the sizes Dialog applies to its own title/description on desktop. */
  title: {
    [BreakPointDesktop]: {
      fontSize: "32px !important",
      lineHeight: "45px !important",
    },
  },
  description: {
    [BreakPointDesktop]: {
      fontSize: "18px !important",
      lineHeight: "25px !important",
    },
  },
  avatarButton: {
    position: "relative",
    alignSelf: "center",
    width: 80,
    height: 80,
    borderRadius: "50%",
    boxSizing: "border-box",
    border: "3px solid transparent",
    backgroundColor: theme.colors.Background4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    [BreakPointMobile]: {
      width: 64,
      height: 64,
    },
  },
  selected: {
    borderColor: theme.colors.TextDefault,
  },
  toggleSelected: {
    outline: `2px solid ${theme.colors.Border4}`,
    outlineOffset: 3,
    borderRadius: 20,
  },
  avatarPreview: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50%",
  },
  avatarPlaceholder: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    overflow: "hidden",
    borderRadius: "50%",
    backgroundColor: "#DFE1E5",
    color: "#7E838D",
    fontSize: 56,
    lineHeight: 1,
    [BreakPointMobile]: {
      fontSize: 45,
    },
  },
  avatarIcon: {
    position: "relative",
  },
  rowButton: {
    background: theme.colors.Background,
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
  },
}));
